export default "__VITE_ASSET__hpi09QC$__"